import React, {Component} from 'react';
import styled from 'styled-components';
import Input, {InputLabel} from '@material-ui/core/Input';
import {FormControl, FormHelperText} from '@material-ui/core';
import Select from '@material-ui/core/Select';
import {FormattedMessage} from "react-intl";

/**
 * Fabric selection component.
 */
class CountrySelection extends Component {

    buildOptions = () => {
        const options = [
            <option value="9"><FormattedMessage id="COUNTRY-AUSTRIA" defaultMessage="Österreich" /></option>,
            <option value="16"><FormattedMessage id="COUNTRY-BELGIUM" defaultMessage="Belgien" /></option>,
            <option value="22"><FormattedMessage id="COUNTRY-BOSNIEN" defaultMessage="Bosnien und Herzegovina" /></option>,
            <option value="25"><FormattedMessage id="COUNTRY-BULGRARIA" defaultMessage="Bulgarien" /></option>,
            <option value="40"><FormattedMessage id="COUNTRY-CROATIA" defaultMessage="Kroation" /></option>,
            <option value="41"><FormattedMessage id="COUNTRY-CYPRUS" defaultMessage="Zypern" /></option>,
            <option value="42"><FormattedMessage id="COUNTRY-CZECH" defaultMessage="Tschechische Republik" /></option>,
            <option value="59" selected><FormattedMessage id="COUNTRY-GERMANY" defaultMessage="Deutschland" /></option>,
            <option value="43"><FormattedMessage id="COUNTRY-DENMARK" defaultMessage="Dänemark" /></option>,
            <option value="50"><FormattedMessage id="COUNTRY-ESTONIA" defaultMessage="Estland" /></option>,
            <option value="53"><FormattedMessage id="COUNTRY-FINLAND" defaultMessage="Finnland" /></option>,
            <option value="54"><FormattedMessage id="COUNTRY-FRANCE" defaultMessage="Frankreich" /></option>,
            <option value="61"><FormattedMessage id="COUNTRY-GREECE" defaultMessage="Griechenland" /></option>,
            <option value="68"><FormattedMessage id="COUNTRY-HUNGARY" defaultMessage="Ungarn" /></option>,
            <option value="69"><FormattedMessage id="COUNTRY-ICELAND" defaultMessage="Island" /></option>,
            <option value="74"><FormattedMessage id="COUNTRY-IRELAND" defaultMessage="Irland" /></option>,
            <option value="76"><FormattedMessage id="COUNTRY-ITALY" defaultMessage="Italien" /></option>,
            <option value="85"><FormattedMessage id="COUNTRY-LATVIA" defaultMessage="Lettland" /></option>,
            <option value="90"><FormattedMessage id="COUNTRY-LIECHTENSTEIN" defaultMessage="Liechtenstein" /></option>,
            <option value="91"><FormattedMessage id="COUNTRY-LITHUANIA" defaultMessage="Litauen" /></option>,
            <option value="92"><FormattedMessage id="COUNTRY-LUXEMBOURG" defaultMessage="Luxemburg" /></option>,
            <option value="102"><FormattedMessage id="COUNTRY-MOLDAVIA" defaultMessage="Republic Moldavien" /></option>,
            <option value="103"><FormattedMessage id="COUNTRY-MONACO" defaultMessage="Monaco" /></option>,
            <option value="109"><FormattedMessage id="COUNTRY-NETHERLANDS" defaultMessage="Niederlande" /></option>,
            <option value="116"><FormattedMessage id="COUNTRY-NORWAY" defaultMessage="Norwegen" /></option>,
            <option value="123"><FormattedMessage id="COUNTRY-POLAND" defaultMessage="Polen" /></option>,
            <option value="124"><FormattedMessage id="COUNTRY-PORTUGAL" defaultMessage="Portugal" /></option>,
            <option value="129"><FormattedMessage id="COUNTRY-RUSSIA" defaultMessage="Russland" /></option>,
            <option value="266"><FormattedMessage id="COUNTRY-SERBIA" defaultMessage="Serbien" /></option>,
            <option value="138"><FormattedMessage id="COUNTRY-SLOVAKIA" defaultMessage="Slovakei" /></option>,
            <option value="139"><FormattedMessage id="COUNTRY-SLOVENIA" defaultMessage="Slovenien" /></option>,
            <option value="143"><FormattedMessage id="COUNTRY-SPAIN" defaultMessage="Spanien" /></option>,
            <option value="148"><FormattedMessage id="COUNTRY-SWEDEN" defaultMessage="Schweden" /></option>,
            <option value="149"><FormattedMessage id="COUNTRY-SWITZERLAND" defaultMessage="Schwweiz" /></option>,
            <option value="262"><FormattedMessage id="COUNTRY-UNITED KINGDOM" defaultMessage="England" /></option>,
        ];
        return options;
    };

    render() {

        const StyledSelect = styled(Select)`
            margin-top: 16px;
        `;

        return (
            <FormControl>
                <StyledSelect
                    native
                    defaultValue={"59"}
                    input={<Input id="COUNTRY-mce-MMERGE3-country"
                                  name="MMERGE3[country]"/>}
                >
                    {this.buildOptions()};
                </StyledSelect>
                <FormHelperText>
                    <FormattedMessage
                        id="COUNTRY-FORM_HELP_SELECT_COUNTRY"
                        desctiption="Helper text below the country select field."
                        defaultMessage="Land auswählen"
                    />
                </FormHelperText>
            </FormControl>
        );
    }
};

export default CountrySelection;



// WEBPACK FOOTER //
// ./src/components/newsletter/CountrySelection.js